import { ReactNode, CSSProperties } from 'react'
import { ReactComponent as CloseIcon } from 'assets/icons/IconClose.svg'
import css from './chip.module.css'
import cn from 'utils/cn'

interface IProps {
  onClick?: () => void
  onDelete?: () => void
  label?: string
  variant?: 'active' | 'normal'
  disabled?: boolean
  style?: CSSProperties
  avatar?: ReactNode
}

const Chip = (props: IProps) => {
  const className = () => {
    let className: string = css.container

    if (props.disabled) {
      return cn(className, css.disabled)
    }

    if (!!props.onClick) {
      className = cn(className, css.clickable)
    }

    if (props.variant === 'active') {
      return cn(className, css.active)
    }

    return className
  }

  const handleDelete = (e: React.MouseEvent) => {
    e.stopPropagation()
    props.onDelete()
  }

  return (
    <div
      onClick={props.disabled ? undefined : props.onClick}
      className={className()}
      style={props.style}
      title={props.label ?? '-'}
    >
      <div className={css.label}>
        {props.avatar && <div className={css.avatar}>{props.avatar}</div>}
        <div className={'line_clamp'}>{props.label ?? '-'}</div>
      </div>
      {!!props.onDelete && <CloseIcon className='delete-icon' onClick={handleDelete} />}
    </div>
  )
}

export default Chip
